<template>
  <div class="dash-pro-item mb-30 dashboard-widget">
    <div class="header">
      <h4 class="title">Documentos do Lote</h4>
      <span class="text-muted">{{ getAgLote?.numeroLote }} - {{ getAgLote?.descricao }}</span>
    </div>

    <div class="row" v-if="loading">
      <div class="col-12 text-center py-5">
        <i class="fa fa-spin fa-spinner"></i>&nbsp;Carregando documentos...
      </div>
    </div>

    <div class="row" v-else-if="mensagemErro">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          {{ mensagemErro }}
        </div>
      </div>
    </div>

    <div class="row" v-else-if="documentos && documentos.length === 0">
      <div class="col-12 text-center py-5">
        <p>Nenhum documento encontrado para este lote.</p>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Tipo Documento</th>
                <th class="text-center">Baixar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="documento in documentos" :key="documento.documentoId">
                <td class="align-middle">{{ documento.tipoDocumento }}</td>
                <td class="text-center align-middle">
                  <a
                    v-if="documento.url"
                    :href="documento.url"
                    target="_blank"
                    class="btn btn-xs btn-primary"
                    title="Baixar documento"
                  >
                    <i class="fa fa-download"></i>
                  </a>
                  <span v-else class="text-muted">Sem arquivo</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 text-center mt-2">
        <Button desc="Voltar" :width="45" :disabled="loading" tela="lotes"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Button from './components/AgButton.vue';

export default {
  name: 'DocumentosLote',
  components: {
    Button,
  },
  data: () => ({
    loading: false,
    mensagemErro: null,
    documentos: [],
  }),
  computed: {
    ...mapGetters(['getAgLote']),
  },
  methods: {
    ...mapActions(['documentosLote']),
    ...mapMutations(['setAgTela']),
    async getDocumentos() {
      if (!this.getAgLote?.loteId) {
        this.mensagemErro = 'Lote não encontrado.';
        return;
      }

      this.loading = true;
      this.mensagemErro = null;

      try {
        const resp = await this.documentosLote(this.getAgLote.loteId);
        this.documentos = resp.data.data.filter(d => d.statusId === 5) || [];
      } catch (error) {
        this.mensagemErro = error.response?.data?.Message || 'Não foi possível carregar os documentos.';
        this.documentos = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getDocumentos();
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #52606d;
  font-size: 0.85rem;
}

.table td {
  font-size: 0.85rem;
  vertical-align: middle;
}

.table td.align-middle {
  vertical-align: middle;
}

.btn-xs {
  padding: 0.15rem 0.4rem;
  font-size: 0.75rem;
  line-height: 1.2;
}

.badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .table {
    font-size: 0.75rem;
  }

  .table th,
  .table td {
    padding: 0.5rem;
  }
}
</style>

